import { SafeDictionary } from "@insite/client-framework/Common/Types";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { CustomHandler } from "@tKgpco/Store/CustomHandlerCreator";

type HandlerType = CustomHandler<{
    ids: string[];
}>;

export const DispatchToggleSelectedTerms: HandlerType = props => {
    props.dispatch({
        type: "Custom/Terms/ToggleSelectedTerms",
        ids: props.parameter.ids,
    });
};

export const chain = [DispatchToggleSelectedTerms];

const selectTerms = createHandlerChainRunner(chain, "SelectTerms");
export default selectTerms;
